export const shopDeliveryText = (shop: any) => {
  let displayText = '';

  if (shop?.receiveDelivery) {
    displayText += 'รับของที่ร้าน';
  }
  if (shop?.normalDelivery) {
    if (displayText !== '') displayText += ' / ';
    displayText += 'บริการจัดส่ง';
  }
  if (shop?.specialDelivery) {
    if (displayText !== '') displayText += ' / ';
    displayText += 'ส่งด่วน';
  }

  return displayText;
};

export const convertPrice = (value: any) => {
  value = value || 0;
  return value
    .toFixed(2)
    .toString()
    .replace(/\D/g, '')
    .replace(/(\d)(\d{2})$/, '$1.$2')
    .replace(/(?=(\d{3})+(\D))\B/g, ',');
};

export const numberFormat = (value: any) => {
  value = value || 0;
  return value
    .toFixed(2)
    .toString()
    .replace(/\D/g, '')
    .replace(/(\d)(\d{2})$/, '$1.$2')
    .replace(/(?=(\d{3})+(\D))\B/g, ',');
};
